import { useEffect, useState } from "react";
import { UIText } from "../../components";
import FullScreenLayout from "../../layouts/FullScreenLayout";
import { ScrollView, Square, Spacer, Separator, Tabs, XStack } from "tamagui";
import ShoppingListScreen from "./ShoppingList";
import MyShelfScreen from "./MyShelf";
import Ionicons from "@expo/vector-icons/Ionicons";

function TabView({ name, title, tabState }) {
  return (
    <Tabs.Tab
      flex={1}
      height={27}
      value={name}
      borderBottomWidth={tabState.currentTab === name ? 2 : 0}
      borderColor="#303030"
    >
      <UIText
        fontWeight={600}
        color={tabState.currentTab === name ? "black" : "#4D4C4C"}
      >
        {title}
      </UIText>
    </Tabs.Tab>
  );
}

export default function IngredientsScreen({ route }) {
  const { toTab = "shop" } = route.params || {};
  const [tabState, setTabState] = useState({
    activeAt: null,
    currentTab: toTab,
    intentAt: null,
    prevActiveAt: null,
  });

  useEffect(() => {
    setTabState((prev) => ({ ...prev, currentTab: toTab }));
  }, [toTab]);

  const setCurrentTab = (currentTab) =>
    setTabState({ ...tabState, currentTab });

  const { currentTab } = tabState;

  /**
   * TODO:
   * There seems to be a bug(?) with the TabViews where they does not navigate to
   * "shelf" when toTab is set to "shelf" in this scenario:
   * 1. From the "shop" tab navigate to the cart screen
   * 2. Select some ingredient(s) and add it/them to your shelf
   * 3. Should land on "shelf tab". Navigate back to the "shop" tab and repeat step 1 & 2
   * 4. Will now instead land on "shop" tab 🤷‍♂️
   */

  return (
    <FullScreenLayout>
      <XStack justifyContent="space-between" width="100%">
        <Spacer width={100} />
        <UIText py={18} fontWeight={700}>
          FoodX
        </UIText>
        <XStack width={100} padding={8} gap={16} justifyContent="flex-end">
          <Square pressStyle={{ opacity: 0.5 }}>
            <Ionicons name="search" size={20} />
          </Square>
          <Square pressStyle={{ opacity: 0.5 }}>
            <Ionicons name="ellipsis-horizontal" size={20} />
          </Square>
        </XStack>
      </XStack>
      <Tabs
        defaultValue="shop"
        width={400}
        flexDirection="column"
        value={currentTab}
        onValueChange={setCurrentTab}
        flex={1}
        px={16}
      >
        <Tabs.List paddingHorizontal={16} gap={16}>
          <TabView name="shop" title="Shop" tabState={tabState} />
          <TabView name="shelf" title="My Shelf" tabState={tabState} />
        </Tabs.List>
        <Separator borderColor="#D9D9D9" />
        <ScrollView flex={1}>
          <Tabs.Content value="shop">
            <ShoppingListScreen />
          </Tabs.Content>
          <Tabs.Content value="shelf">
            <MyShelfScreen />
          </Tabs.Content>
        </ScrollView>
      </Tabs>
    </FullScreenLayout>
  );
}
